//import packages from node modules
import React, { useEffect, useRef, useState,Fragment,useCallback } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import renderHTML from 'react-render-html'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

//import utility functions
import { updateCartItem, deleteCartItem, clearCart } from '../../../app/action'
import Loading from '../../shared/loading'
import {
  addClassToDOM,
  removeCssClass,
  moveLiveChatStyling,
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../utilities/function/common'

import {
  getCartToken
} from "../../../utilities/function/cartToken"

import {
  getServiceTypeFromProductConfig,
  getUpdateProductConfigPayload,
  getDomainNamePayloadFromConfig,
  getAttributes
} from '../../../utilities/function/configuration'

import {
  getBillingCycleDataFromProductConfig,
  getPriceByBillingCycleID,
  getCycle
} from '../../../utilities/function/billingCycle'

import {
  getDataFromURL
} from '../../../utilities/function/urlparams'

import {
  getIconSlugBasedOnServiceType,
  renderCommonCartItem
} from '../../../utilities/function/manageServiceTypes'
import { DOMAIN_TYPE, SSL_TYPE } from '../../../utilities/function/servicetype'

//import shared components
import KeepShoppingButton from '../closebutton/keepShoppingButton'
import SolidButton from '../button/solidbutton'
import PromotionForm from '../promotion/form'
import PremiumFlag from '../premiumflag'
import Ellipsis from "../ellipsis";
import {onSale} from "../pricedomain";

export let EditOptions = (props) => {
  const {cartItem, productConfig, history} = props
  const dispatch = useDispatch()
  if (cartItem && productConfig) {
    const {uuid} = cartItem
    const service_type = getServiceTypeFromProductConfig(productConfig)
    const deleteCallback = () => {
      const payload = {
        token: getCartToken(),
        uuid
      }
      deleteCartItem(payload, dispatch, history)
    }
    const editCallback = () => {
      if (service_type === DOMAIN_TYPE) {
        history.push(`${history.location.pathname}?a=confdomain&uuid=${uuid}`)
      } else {
        history.push(`${history.location.pathname}?a=edit&uuid=${uuid}`)
      }
    }
    const isSSL = () =>{
      if(productConfig && getAttributes(productConfig.selectedProduct)){
        const {service_type} = getAttributes(productConfig.selectedProduct)
        if(service_type===SSL_TYPE){
          return true
        }
      }
      return false
    }
    return (
      <div className={`of-cart-edit-options${isSSL()?' of-cart-edit-options--SSL':''}`}>
        <div className='of-cart-edit-options__wrapper'>

          {!isSSL()?<button
            className='lines-border-1-100 of-cart-edit-options__button of-cart-edit-options__button--edit'
            type='button' onClick={editCallback}><i className='icon icon-of-pencil text-font-4-100'/></button>:<></>}
          <button
            className='lines-border-1-100 of-cart-edit-options__button of-cart-edit-options__button--remove'
            type='button' onClick={deleteCallback}><i className='icon icon-of-delete status-font-2-100'/></button>
        </div>
      </div>
    )
  }

  return (<></>)
}
EditOptions.propTypes = {
  cartItem: PropTypes.object,
  productConfig: PropTypes.object,
  history: PropTypes.object
}
EditOptions = withRouter(EditOptions)

export let CartBillingCycleDropdown = (props) => {
  const dispatch = useDispatch()
  const {cartData} = useSelector(state=>({
    cartData: state.app.cartData
  }))
  const {productConfig, cartItem, history} = props
  const {
    uuid,
    billing_cycle_id,
  } = cartItem

  const callback = (billing_cycle_id) => {
    let payload = getUpdateProductConfigPayload(productConfig,cartData,uuid)
    const serviceType = getServiceTypeFromProductConfig(productConfig)
    if(serviceType===DOMAIN_TYPE){
      payload.items = getDomainNamePayloadFromConfig(productConfig)
    }
    if(payload){
      if(payload.items){
        payload.items.billing_cycle_id = billing_cycle_id
        if (payload.items.addons && payload.items.addons.length) {
          payload.items.addons.forEach((addon, index) => {
            if (payload.items.addons[index] && payload.items.addons[index].billing_cycle_id) {
              payload.items.addons[index].billing_cycle_id = billing_cycle_id
            }
          })
        }
      }
    }
    updateCartItem(payload, dispatch, history)
  }
  const [isOpen, setIsOpen] = useState(false)
  const toggle = (e) => {
    e.preventDefault()
    setIsOpen(!isOpen)
  }
  const bindClickAway = (e) => {
    e.preventDefault()
    if (dropdownRef && dropdownRef.current && e.target) {
      if (dropdownRef.current !== e.target && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
  }
  useEffect(function () {
    if (isOpen) {
      document.addEventListener('click', bindClickAway)
      document.addEventListener('touchstart', bindClickAway)
    }
    if (isOpen === false) {
      document.removeEventListener('click', bindClickAway)
      document.removeEventListener('touchstart', bindClickAway)
    }
    return (() => {
      document.removeEventListener('click', bindClickAway)
      document.removeEventListener('touchstart', bindClickAway)
    })
  }, [isOpen])
  const renderItems = (list) => {
    if (list && list.length) {
      return list.map((item, index) => {
        const {name, price} = item
        return (
          <li key={index} className='of-cart-bc-dropdown__item'>
            <div className='of-cart-bc-dropdown__button text-font-3-100'
                 onClick={(e) => {
                   e.preventDefault()
                   e.stopPropagation()
                   setIsOpen(false)
                   callback(item.billing_cycle_id)
                 }}
                 onMouseEnter={e => {
                   const el = e.currentTarget
                   addClassToDOM(el, 'shades-primary-background-2-100')
                 }} onMouseLeave={e => {
              const el = e.currentTarget
              removeCssClass(el, 'shades-primary-background-2-100')
            }}
            >
              <span className={'text-font-1-100'}>{name} - </span>
              <strong className={'text-font-1-100'}>${price}</strong>
              <span className={'cycle'}>{getCycle(name)}</span>
            </div>
          </li>
        )
      })
    }
    return (<></>)
  }
  const dropdownRef = useRef(null)
  const renderList = () => {
    const priceList = getBillingCycleDataFromProductConfig(productConfig)

;

    if (priceList && priceList.length && isOpen) {
      const {order_type} = productConfig
      const filtered = priceList.filter(item => item.type === order_type)
      if (order_type) {
        return (
          <ul className='of-cart-bc-dropdown__list lines-border-1-100'>{renderItems(filtered)}</ul>
        )
      }
      return (
        <ul className='of-cart-bc-dropdown__list lines-border-1-100'>{renderItems(priceList)}</ul>
      )
    }
    return (<></>)
  }

  if (productConfig && productConfig.selectedProduct){
    const {price} = getAttributes(productConfig.selectedProduct)
    const priceDetails = getPriceByBillingCycleID(price, billing_cycle_id)
    if (priceDetails) {
      const {name} = priceDetails
      if(price && price.length===1 && Array.isArray(price)){
        const priceObj = price[0]
        return (
          <div className={'of-cart-bc-label text-font-3-100'}>{priceObj.name}</div>
        )
      }
      return (
        <div className='of-cart-bc-dropdown' ref={dropdownRef}>
          <div
            className={`of-cart-bc-dropdown__selected ${isOpen ? 'of-cart-bc-dropdown__selected--open primary-border-1-100' : 'lines-border-1-100'}`}>
            <div className='of-cart-bc-dropdown__button text-font-3-100' onClick={toggle}>
              {name}
              <div className='of-cart-bc-dropdown__icon-of-wrapper'>
                <i className='icon icon-of-arrow text-font-3-100'/>
              </div>
            </div>
          </div>
          {renderList()}
        </div>
      )
    }
  }
  return (<></>)
}

CartBillingCycleDropdown.propTypes = {
  productConfig: PropTypes.any,
  cartItem: PropTypes.object,
  history: PropTypes.object
}

CartBillingCycleDropdown = withRouter(CartBillingCycleDropdown)

export const renderPrice = (service_type, item, price, billing_cycle_id, isTotal = false) => {

  if (item && price) {
    const priceDetails = getPriceByBillingCycleID(price, billing_cycle_id)
    if (priceDetails) {
      const {name,old_price} = priceDetails
      const cycle = getCycle(name)
      const {discount_amount, discount, order_type} = item
      const getProductTotal = (subtotal = false) => {
        const {total_amount, subtotal_amount} = item
        if (subtotal) {
          return parseFloat(subtotal_amount) || 0
        }
        return parseFloat(total_amount) || 0
      }
      const getAddonTotal = (subtotal = false) => {
        let addonTotal = 0
        const {addons} = item
        if (addons && addons.length) {
          addons.forEach((addon) => {
            const {total_amount, subtotal_amount} = addon
            if (subtotal) {
              addonTotal += parseFloat(subtotal_amount) || 0
            } else {
              addonTotal += parseFloat(total_amount) || 0
            }
          })
        }
        return addonTotal
      }
      const getSavedAmount = (subtotal, total) => {
        if (subtotal>=0  && total >=0) {
          const diff = subtotal - total
          return diff
        }
        return 0
      }
      const productTotal = getProductTotal()
      const total = productTotal + getAddonTotal()
      const subtotal = getProductTotal(true) + getAddonTotal(true)
      const savetotal = getSavedAmount(subtotal, total)
      const renderTotal = (total, cycle) => {
        if (total > 0) {
          return <><span className={`total-amount text-font-1-100`}>${total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</span><span
            className='cycle text-font-3-100'>{cycle ? cycle : ''}</span></>
        }
        return <span className={`total-amount total-amount--free status-font-1-100`}>FREE</span>
      }
      if (service_type === DOMAIN_TYPE) {
        if (order_type === 'transfer') {
          return <><span className='total-amount text-font-1-100'>{renderTotal(subtotal,cycle)}</span></>
        }
      }
      if (isTotal) {
        const isDiscount = () => discount_amount && parseFloat(discount_amount) > 0 && discount
        const renderBeforePrice = () => {
          if(isDiscount()){
            return subtotal.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
          }
          if(onSale(old_price)){
            return old_price.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
          }
          return <></>
        }
        const renderDiscountInfo = () => {
          if(isDiscount()){
            return(
                <div className={'of-total-amount-discount__coupon status-font-3-100'}>
                  {discount} Coupon Applied (You saved ${savetotal.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)})
                </div>
            )
          }
         return (<></>)
        }
        if (isDiscount() || onSale(old_price)) {
          return (
            <div className={`of-total-amount-discount`}>
              <div className={'of-total-amount-discount__price'}>
                <div className={'of-total-amount-discount__before-price text-font-4-100'}>
                  <div className={'amount'}>${renderBeforePrice()}</div>
                  <div className={'cycle'}>{cycle}</div>
                </div>
                <div className={'of-total-amount-discount__after-price'}>
                  <div className={'amount status-font-3-100'}>${total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</div>
                  <div className={'cycle status-font-3-100'}>{cycle}</div>
                </div>
              </div>
              {renderDiscountInfo()}
            </div>
          )
        }
        return (renderTotal(total, cycle))
      } else {
        return (renderTotal(productTotal, cycle))
      }

    }
  }
  return <></>
}

export const renderIcon = (productConfig) => {
  let slug = getIconSlugBasedOnServiceType(productConfig)
  return (<i className={`of-cart-item__icon icon-of-${slug} primary-font-1-100`}/>)
}


const meta_keys = {
  auto_renew: 'Auto Renew',
  id_protection: 'ID Protection'
}


let CartItem = (props) => {
  const {item, configurations} = props
  const {
    uuid,
    billing_cycle_id
  } = item
  const productConfig = configurations[uuid]

  const {viewport} = useSelector(state => state.app)
  const service_type = getServiceTypeFromProductConfig(productConfig)
  if (productConfig && productConfig.selectedProduct && productConfig.selectedProduct.attributes && item) {
    const getProductDetails = () => {
      if (productConfig && productConfig.selectedProduct && productConfig.selectedProduct.attributes) {
        return productConfig.selectedProduct.attributes
      }
      return null
    }
    const renderDomain = () => {
      if (item && getProductDetails()) {
        const {price} = getProductDetails()
        const {name, order_type,is_premium} = item
        const renderMeta = () =>{
          return (Object.keys(meta_keys).map((key)=>{
            if(item[key]){
              return (<div key={key} className='of-cart-item__product-info of-cart-item__product-info--meta'>
                <span className={'label text-font-1-100'}>{meta_keys[key]}</span>
                <span className={'value text-font-3-100'}> is enabled</span>
              </div>)
            }
            return (<Fragment key={key}/>)
          }))
        }
        const renderPriceDropdown = () => {
          if(order_type==='register' && !is_premium){
            return(<CartBillingCycleDropdown
              productConfig={productConfig}
              cartItem={item}
            />)
          }
          return (<></>)
        }
        const renderName = () =>{
          const isActive = ()=>{
            return name && name.length > 25
          }
          const renderFormat = () => {
            const first10 = name.substring(0, 10)
            const last10 = name.substring(name.length - 10)
            return (
                <div className={'text-font-1-100 of-cart-item__product-name'}>{first10}...{last10}</div>)
          }
          return(<>
            <Ellipsis format={renderFormat()} tooltip={name} isActive={isActive()}>
              <div className={'text-font-1-100 of-cart-item__product-name'}>{name}</div>
            </Ellipsis>
          </>)
        }
        const renderInfo = () =>{
          switch (order_type) {
            case 'register':
              return `${viewport!=="xs"?'Domain Name ':''}Registration`
            case 'transfer':
              return 'Domain Name Transfer'
            default:
              return order_type
          }
        }
        return (<div className='of-cart-item'>
          <div className='of-cart-item__row of-cart-item__row--product lines-border-1-100'>
            <div className='of-cart-item__wrapper'>
              <div className='of-cart-item__left'>
                {renderIcon(productConfig)}
                {renderName()}
                <div className='of-cart-item__product-info text-font-3-100'>
                  <PremiumFlag itemresult={item} textmode={true} /><div className={`of-cart-item__product-info-desc`}>{renderInfo()}</div> </div>
                {renderMeta()}
              </div>
              <div className='of-cart-item__right'>
                <div
                  className='of-cart-item__price'>
                  {renderPrice(service_type, item, price, billing_cycle_id, true)}
                </div>
              </div>
            </div>
            <div className='of-cart-item__wrapper of-cart-item__wrapper--cycle'>
              <div className='of-cart-item__left'>
                {renderPriceDropdown()}
              </div>
              <div className='of-cart-item__right'>
                <EditOptions cartItem={item} productConfig={productConfig}/>
              </div>
            </div>
          </div>
        </div>)
      }
      return (<></>)
    }
    if (service_type === DOMAIN_TYPE) {
      return renderDomain()
    }
    return renderCommonCartItem(productConfig, item)
  }
  return (<></>)
}

CartItem = withRouter(CartItem)

CartItem.propTypes = {
  item: PropTypes.object,
  configurations: PropTypes.object,
  dispatch: PropTypes.any,
  history: PropTypes.any
}




export const renderCTA = (cartData, buttonLabel, buttonOnClick, padlock, lcMaximized,getUser=null,useCredit=true) => {
  if (cartData) {
    const {items} = cartData
    if (items && items.length > 0) {
      const renderTotal = () => {
        const {total_amount, total_discount_amount} = cartData
        const getTotalAmount = () => {
          if(getUser && getAttributes(getUser.data) && useCredit){
            const {credit} = getAttributes(getUser.data)
            if(total_amount && credit && parseFloat(credit)){
              const total = parseFloat(total_amount) - parseFloat(credit)
              return total < 0 ? 0 : total
            }
          }
          return total_amount
        }
        const totalAmount = getTotalAmount()
        const products_total_amount = parseFloat(totalAmount) + parseFloat(total_discount_amount)
        if (total_discount_amount && parseFloat(total_discount_amount) === 0) {
          return (<div className={'of-cart-main-cta__total'}>
            <div className={'of-cart-main-cta__total-after text-font-1-100'}>${parseFloat(totalAmount) || parseFloat(totalAmount)===0?parseFloat(totalAmount).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS):''}</div>
          </div>)
        }
        return (<div className={'of-cart-main-cta__total of-cart-main-cta__total'}>
          <div className={'of-cart-main-cta__total-before text-font-3-100'}>${products_total_amount.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</div>
          <div className={'of-cart-main-cta__total-after status-font-3-100'}>${parseFloat(totalAmount) || parseFloat(totalAmount)===0?parseFloat(totalAmount).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS):''}</div>
        </div>)
      }
      const moveLiveChat = () => {
        return (renderHTML(moveLiveChatStyling(lcMaximized)))
      }
      return (
        <div className={'of-cart-main-cta clearfix'}>
          <div className={'of-cart-main-cta__total-wrapper'}>
            <div className={'of-cart-main-cta__label text-font-3-100'}>Total Amount</div>
            {renderTotal()}
          </div>
          <SolidButton isSecondary={true} className={'of-cart-main-cta__button text-font-1-100'}
                       onClick={buttonOnClick}>
            {padlock ? <i className={'of-cart-main-cta__button-icon icon-of-lock'}/> : <></>}{buttonLabel}</SolidButton>
          {moveLiveChat()}
        </div>
      )
    }
  }
  return (<></>)
}

let Cart = (props) => {
  const {history, location,className} = props
  const dispatch = useDispatch()
  const initFlag = useRef(false)
  const {cartStatus, cartData,viewport} = useSelector(state => state.app)
  const configurations = useSelector(state => state.app.configurations, shallowEqual)

  const [lcMaximized, setLcMaximized] = useState(false)
  useEffect(() => {
    const onVisibilityChanged = (data) => {
      switch (data.visibility) {
        case 'maximized':
          setLcMaximized(true);
          break
        case 'minimized':
          setLcMaximized(false);
          break
        case 'hidden':
          setLcMaximized(false);
          break
        default:
          break
      }
    }
    try {
      if (window && window.LiveChatWidget){
        window.LiveChatWidget.on('visibility_changed', function (data) {
          onVisibilityChanged(data);
        })
        window.LiveChatWidget.off('visibility_changed', function (data) {
          onVisibilityChanged(data);
        })
      }
    } catch (e) {
      console.log(e)
    }
  },[lcMaximized])


  const {cart_quick_links} = window.app_config
  useEffect(() => {
    if (!initFlag.current) {
      // /appInit(dispatch, history, true)
      initFlag.current = true
    }
  }, [initFlag, dispatch, history])
  const renderCartList = () => {
    if (cartData) {
      const {items} = cartData
      if (items && items.length > 0) {

        return items.map((item, index) => {
          return (
            <CartItem key={index} item={item} configurations={configurations} dispatch={dispatch} history={history}/>)
        })
      }

    }
    return (<></>)
  }
  const renderTerms = () => {
    if (cartData) {
      const {items} = cartData
      if (items && items.length > 0)
        return (<div className='of-cart-main__terms text-font-4-100'>All prices are shown in AUD</div>)
    }
    return (<></>)
  }
  const clearCartCallback = useCallback((e)=>{
    e.preventDefault()
    clearCart(dispatch,history)



  },[dispatch,history])
  const renderClearCart = () =>{
    return (
      <div className={'of-clear-cart of-cart-main__clear'}>
        <button onClick={clearCartCallback} className={'status-font-2-100 of-clear-cart__button of-link'}>Clear Cart</button>
      </div>
    )
  }
  const buttonOnClick = e => {
    e.preventDefault()
    history.push(`${history.location.pathname}?a=checkout&step=account`)
  }
  const renderMain = (lcMaximized) => {
    if (cartStatus === 'success' || cartStatus === 'error') {
      if (cartData && cartData.items && cartData.items.length > 0) {
        const buttonText = viewport==="xs"? "Checkout":"Proceed to Secure Checkout"
        return (<>
          <div className='of-cart-main'>
            <div className='of-cart-main__wrapper clearfix'>
              <div className={'of-cart-main__more'}>
                {renderClearCart()}
                {renderTerms()}
              </div>
              {renderCartList()}
              <PromotionForm/>
            </div>
          </div>
            {renderCTA(cartData, buttonText, buttonOnClick, true, lcMaximized)}
          </>
        )
      }
      const renderQuickLinks = () => {
        if(cart_quick_links){
          return (
            <div className={'of-cart-empty__quick-links primary-font-1-100'}>
              {renderHTML(cart_quick_links)}
            </div>
          )
        }
        return (<></>)
      }
      return (
        <div className={'of-cart-empty'}>
          <i className={'of-cart-empty__icon icon-of-empty-cart'}/>
          <div className={'of-cart-empty__heading'}>Your shopping cart is empty!</div>
          {renderQuickLinks()}
        </div>
      )
    }
    return (<></>)
  }
  const renderLoading = () => {
    const {a} = getDataFromURL(location.search)
    if (cartStatus === 'loading' || cartStatus === undefined) {
      if (a === 'viewcart') {
        return (<Loading className={'cart-loading'}/>)
      } else if (a === 'checkout') {
        return (<Loading className={'cart-loading'} wrapper={true}/>)
      }
    }
    return (<></>)
  }
  const renderKeepShoppingButton = () => {
    const {a} = getDataFromURL(location.search)
    if (a === 'checkout') {
      return (<KeepShoppingButton/>)
    }
    return (<></>)
  }
  return (<div className={`of-cart${className?' '+className:''}`}>
    <div className='of-cart-header'>
      <div className='of-cart-header__heading'>
        <i className='of-cart-header__icon primary-background-1-100 icon-of-shopping-cart'/>
        <span className='of-cart-header__text text-font-1-100'>Your Cart</span>
      </div>
      {renderKeepShoppingButton()}
    </div>
    {renderMain(lcMaximized)}
    {renderLoading()}
  </div>)
}

Cart.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
  className: PropTypes.string
}

Cart = withRouter(Cart)

export default Cart